export const CREDIT_REPORT_PAYMENT_TERMS = {
  M: "Monthly",
  B: "Bi-weekly",
  W: "Weekly",
  SM: "Semi-monthly",
  Q: "Quarterly",
  A: "Annually",
  SA: "Semi-annually",
};

export const CREDIT_REPORT_INQUIRY_TYPES = {
  I: "Individual",
  C: "Contractually Liable",
  A: "Authorized or Spouse User",
  P: "Participating",
};
